'use client'
import { Table, TableRow, TableHeader, TableCell, ColorButton, ConfirmMessage } from "@/components/ui";
import { deleteClientSeller, getClientSeller } from "@/app/api";
import { clientSellerResponseType, defaultClientSeller } from "@/types";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export function DeleteClientSeller({ id }: { id: string }) {
    const router = useRouter();
    const [loading, setLoading] = useState<boolean>(false)
    const [openMessage, setOpenMessage] = useState<boolean>(false)
    const [clientSellerData, setClientSellerData] = useState<clientSellerResponseType>()

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getClientSeller(id)
                if (response !== undefined) {
                    setClientSellerData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o usuário: ', e)
            }
        }

        fetchUser()
    }, [id]);

    const clientSeller = clientSellerData || defaultClientSeller

    const handleDeleteClientSeller = async () => {
        setLoading(true)
        try {
            const res = await deleteClientSeller(id)
            if (res) {
                router.back()
            }
        } catch (err) {
            console.log("Erro ao excluir retorno: ", err);
        } finally {
            setLoading(false);
        }
    }



    return (
        <div>
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableHeader>Empresa</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Data do Cadastro</TableHeader>
                            <TableHeader>Data da Atualização</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{clientSeller.client.code}</TableCell>
                            <TableCell>{clientSeller.client.userName}</TableCell>
                            <TableCell>{clientSeller.client.name}</TableCell>
                            <TableCell>{new Date(clientSeller.createdAt).toLocaleDateString()}</TableCell>
                            {clientSeller.updatedAt === clientSeller.createdAt
                                ?
                                <TableCell> {"- - - - -"} </TableCell>
                                :
                                <TableCell>{new Date(clientSeller.updatedAt).toLocaleDateString()}</TableCell>
                            }
                        </TableRow>
                        <TableRow>
                            <TableHeader colSpan={2}>Observação</TableHeader>
                            <TableCell colSpan={3}>{clientSeller.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableCell>{clientSeller.client.code}</TableCell>
                            <TableHeader>Empresa</TableHeader>
                            <TableCell>{clientSeller.client.userName}</TableCell>
                            <TableHeader>Nome</TableHeader>
                            <TableCell>{clientSeller.client.name}</TableCell>
                            <TableHeader>Data do Cadastro</TableHeader>
                            <TableCell>{new Date(clientSeller.createdAt).toLocaleDateString()}</TableCell>
                            <TableHeader>Data da Atualização</TableHeader>
                            {clientSeller.updatedAt === clientSeller.createdAt
                                ?
                                <TableCell> {"- - - - -"} </TableCell>
                                :
                                <TableCell>{new Date(clientSeller.updatedAt).toLocaleDateString()}</TableCell>
                            }
                            <TableHeader>Observação</TableHeader>
                            <TableCell>{clientSeller.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>


            <div className="flex flex-col gap-3 p-4  items-center justify-center">
                <ColorButton disabled={loading} onClick={() => setOpenMessage(true)}>
                    {loading ? 'Excluindo...' : 'Excluir'}
                </ColorButton>
            </div>

            <ConfirmMessage
                isOpen={openMessage}
                title="Confirmar exclusão"
                message="Tem certeza que deseja excluir a relação desse cliente com o vendedor? Essa ação não poderá ser desfeita."
                onConfirm={handleDeleteClientSeller}
                onCancel={() => setOpenMessage(false)}
            />
        </div >
    )
}